import { cn } from "@/lib/utils";

export default function KPICard({ label, value, icon: Icon, accent = "blue", hint, testId }) {
  const accentMap = {
    blue: "bg-blue-50 text-blue-700",
    amber: "bg-amber-50 text-amber-700",
    rose: "bg-rose-50 text-rose-700",
    emerald: "bg-emerald-50 text-emerald-700",
    slate: "bg-slate-100 text-slate-700",
  };
  return (
    <div
      data-testid={testId}
      className={cn(
        "bg-white rounded-2xl border border-slate-100 p-6 transition-all duration-300",
        "shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] hover:-translate-y-0.5",
      )}
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.15em] text-slate-400">
            {label}
          </div>
          <div className="mt-3 text-3xl font-bold tracking-tight text-slate-900 font-heading">
            {value}
          </div>
          {hint ? (
            <div className="mt-2 text-xs text-slate-500">{hint}</div>
          ) : null}
        </div>
        {Icon ? (
          <div className={cn("p-3 rounded-xl", accentMap[accent])}>
            <Icon size={22} strokeWidth={1.75} />
          </div>
        ) : null}
      </div>
    </div>
  );
}
